import { render } from "./AppPromptAlert.vue?vue&type=template&id=8196b1c8"
import script from "./AppPromptAlert.vue?vue&type=script&lang=js"
export * from "./AppPromptAlert.vue?vue&type=script&lang=js"

import "./AppPromptAlert.vue?vue&type=style&index=0&id=8196b1c8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__